export var warriorBackround = '_1-bMB';
export var logo = '$_1Nmkp';
export var navMaxWidth = '_3158X';